import { resolveFilesystemReadAccess } from "@heydex/client-runtime/state/filesystem";
import type { EnvironmentId } from "@heydex/contracts";

import { useEnvironmentPresentation } from "./presentation";

export function useFilesystemReadAccess(environmentId: EnvironmentId | null) {
  const environment = useEnvironmentPresentation(environmentId);
  return resolveFilesystemReadAccess({
    isCatalogReady: environment.isReady,
    connection: environment.presentation?.connection ?? null,
  });
}
